import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ALL_ITEMS, MenuItem } from '../services/menu-items';
import { NavItemComponent } from './components/nav-item/nav-item.component';
import { AuthService } from '@core/services/auth.service';
import LoadingComponent from '@shared/components/loading/loading.component';

@Component({
  selector: 'app-nav',
  imports: [MatListModule, NavItemComponent, LoadingComponent],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class NavComponent implements OnInit {
  private _authService = inject(AuthService);
  menuItems: MenuItem[] = [];
  menuChecked = false;

  ngOnInit() {
    this.init();
  }

  private async init() {
    this.menuItems = await this.filterMenuItems(ALL_ITEMS);
    this.menuChecked = true;
  }

  async filterMenuItems(menuItems: MenuItem[]): Promise<MenuItem[]> {
    const filteredItems = await Promise.all(
      menuItems.map(async (item) => {
        const filteredChildren = await this.filterMenuItems(item.children || []);

        const hasPermission = item.permissionNames ? (item.type === 'page' ? await this._authService.checkPermission(item.permissionNames) : true) : true;
        const isCategoryWithNoChildren = item.type === 'category' && filteredChildren.length === 0;

        if ((hasPermission && !isCategoryWithNoChildren) || (item.type === 'page' && hasPermission)) {
          return {
            ...item,
            children: filteredChildren,
          };
        }

        return null;
      }),
    );

    return filteredItems.filter((item) => item !== null) as MenuItem[];
  }
}
